import React, { useState, useEffect } from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
} from "recharts";
import "./DataChart.css";
import useInterval from "../../../hooks/UseInterval";

const DataChart = ({
  chartData,
  title,
  category,
  width,
  height,
  isAutomated,
  isDisabled,
  handleFilter,
  timeInterval,
  refetch,
  fontSize,
  margin,
}) => {
  const [selectedValue, setSelectedValue] = useState("year");
  const [xAxisLabel, setXAxisLabel] = useState("xValue");
  const [data, setData] = useState(chartData);

  useEffect(() => setData(chartData), [chartData]);

  useInterval(() => {
    refetch();
  }, 30000);

  useEffect(() => {
    if (isAutomated) {
      setSelectedValue(timeInterval);
      dataSetter(timeInterval);
    }
  }, [selectedValue, isAutomated]);

  const handleRadioChange = (event) => {
    setSelectedValue(event.target.value);
    dataSetter(event.target.value);
  };

  function dataSetter(value) {
    switch (value) {
      case "today":
        handleFilter("today");
        setXAxisLabel("xValue");
        setData(data);
        break;
      case "week":
        handleFilter("week");
        setXAxisLabel("xValue");
        setData(data);
        break;
      case "month":
        handleFilter("month");
        setXAxisLabel("xValue");
        setData(data);
        break;
      case "year":
        handleFilter("year");
        setXAxisLabel("xValue");
        setData(data);
        break;
      case "yearly":
        handleFilter("yearly");
        setXAxisLabel("xValue");
        setData(data);
        break;
      default:
        setData(data);
    }
  }

  function currencyFormatter(value) {
    const formattedValue = value.toLocaleString("en-GB", {
      style: "currency",
      currency: "GBP",
    });
    return formattedValue.substring(0, formattedValue.indexOf("."));
  }

  function getTotalSales() {
    const totalPrice = data.reduce((sum, item) => sum + item.achievement, 0);
    return totalPrice;
  }

  function getYOY() {
    var achievement = 0;
    var lastYear = 0;
    const YOY = data.reduce((YOY, item) => {
      achievement = item.achievement > 0 ? item.achievement : achievement;
      lastYear = item.lastYear > 0 ? item.lastYear : lastYear;
      return (YOY = ((achievement / lastYear - 1) * 100) | 0);
    }, 0);
    return YOY;
  }

  function getTotalTarget() {
    const totalPrice = data.reduce((sum, item) => sum + item.target, 0);
    return totalPrice;
  }

  /*const getIntroOfPage = (label) => {
    if (label === 'Jan') {
      return "Page A is about men's clothing";
    }
    if (label === 'Feb') {
      return "Page B is about women's dress";
    }
    if (label === 'Page C') {
      return "Page C is about women's bag";
    }
    if (label === 'Page D') {
      return 'Page D is about household goods';
    }
    if (label === 'Page E') {
      return 'Page E is about food';
    }
    if (label === 'Page F') {
      return 'Page F is about baby food';
    }
    return '';
  };
*/

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      const achievement = payload.find((o) => o.dataKey === "achievement")?.value ?? 0;
      const lastYear = payload.find((o) => o.dataKey === "lastYear")?.value ?? 0;
      return (
        <div className="custom-tooltip">
          <p className="intro">{`${label}`}</p>
          {payload.map((obj) => (
            <p className="label">{`${obj.dataKey} : ${currencyFormatter(obj.value)}`}</p>
          ))}
          <p className="desc">{`YOY Growth : ${((achievement / lastYear - 1) * 100) | 0}%`}</p>
        </div>
      );
    }

    return null;
  };

  return (
    <div className="chart-container">
      <div className="row mb-3">
        <div className="col-7">
          <h3 className="chart-title">{title}</h3>
          <div
            className={`date-filter filter-width`}
            role="group"
            aria-label="Basic radio toggle button group"
          >
            {/* <input
              type="radio"
              className="btn-check"
              name={category}
              id={category + "1"}
              value="today"
              checked={selectedValue === "today"}
              onChange={handleRadioChange}
              disabled={isDisabled}
            />
            <label
              className={`btn ${selectedValue === "today" ? "checked" : ""}`}
              htmlFor={category + "1"}
            >
              Today
            </label>

            <input
              type="radio"
              className="btn-check"
              name={category}
              id={category + "2"}
              value="week"
              checked={selectedValue === "week"}
              onChange={handleRadioChange}
              disabled={isDisabled}
            />
            <label
              className={`btn ${selectedValue === "week" ? "checked" : ""}`}
              htmlFor={category + "2"}
            >
              Week
            </label>
            <input
              type="radio"
              className="btn-check"
              name={category}
              id={category + "3"}
              value="month"
              checked={selectedValue === "month"}
              onChange={handleRadioChange}
              disabled={isDisabled}
            />
            <label
              className={`btn ${selectedValue === "month" ? "checked" : ""}`}
              htmlFor={category + "3"}
            >
              Month
            </label> */}
            <input
              type="radio"
              className="btn-check"
              name={category}
              id={category + "4"}
              value="year"
              checked={selectedValue === "year"}
              onChange={handleRadioChange}
              disabled={isDisabled}
            />
            <label
              className={`btn ${selectedValue === "year" ? "checked" : ""}`}
              htmlFor={category + "4"}
            >
              This Year
            </label>
            <input
              type="radio"
              className="btn-check"
              name={category}
              id={category + "5"}
              value="yearly"
              checked={selectedValue === "yearly"}
              onChange={handleRadioChange}
              disabled={isDisabled}
            />
            <label
              className={`btn ${selectedValue === "yearly" ? "checked" : ""}`}
              htmlFor={category + "5"}
            >
              Last 12 Months
            </label>
          </div>
        </div>
        <div className="col-5">
          <div className="stats">
            {/* <small>Total Sales {getYOY()}</small>
            <br />
            <span className="h5 mb-0 bolder-text sales-achievement">
              {currencyFormatter(getTotalSales())}
              <small className="h6 fw-bold">
                /{currencyFormatter(getTotalTarget())}
              </small>
            </span>
            {getTotalSales() > getTotalTarget() ? (
              <>
                <h5 className="sales-stats success">
                  +{currencyFormatter(getTotalSales() - getTotalTarget())}
                </h5>
                <small className="sales-stats success status-warning">
                  Target Surpassed
                </small>
              </>
            ) : (
              <>
                <h5 className="sales-stats danger">
                  -{currencyFormatter(getTotalTarget() - getTotalSales())}
                </h5>
                <small className="sales-stats danger status-warning">
                  To Go
                </small>
              </>
            )} */}
            <small className="h6 fw-bold">YOY Growth</small>
            <br />
            {getYOY() >= 0 ? (
              <>
                <span className="h5 mb-0 bolder-text sales-achievement sales-stats success">
                  {getYOY()} %
                </span>
              </>
            ) : (
              <>
                <span className="h5 mb-0 bolder-text sales-achievement sales-stats danger">
                  {getYOY()} %
                </span>
              </>
            )}
          </div>
        </div>
      </div>
      <LineChart
        width={width}
        height={height}
        data={data}
        margin={{ top: 10, right: 20, left: margin, bottom: 0 }}
      >
        <defs>
          <linearGradient id="colorProfit" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#82ca9d" stopOpacity={0.8} />
            <stop offset="95%" stopColor="#82ca9d" stopOpacity={0} />
          </linearGradient>
          <linearGradient id="colorTarget" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#808080" stopOpacity={0.2} />
            <stop offset="95%" stopColor="#808080" stopOpacity={0} />
          </linearGradient>
          <linearGradient id="colorMinvalue" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#f0ad4e" stopOpacity={0.2} />
            <stop offset="95%" stopColor="#f0ad4e" stopOpacity={0} />
          </linearGradient>
          <linearGradient id="colorYellow" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#E8B84C" stopOpacity={1} />
            <stop offset="95%" stopColor="#FDEFA2" stopOpacity={0.8} />
          </linearGradient>
        </defs>
        <XAxis
          dataKey={xAxisLabel}
          padding={{ top: 10 }}
          color="#19A500"
          fontSize={fontSize}
          fontWeight={900}
        />
        <YAxis
          color="#19A500"
          fontSize={fontSize}
          fontWeight={900}
          tickFormatter={(value) => `${currencyFormatter(value)}`}
        />
        <CartesianGrid strokeDasharray="4 4" />
        <Tooltip content={<CustomTooltip />} />
        {data.some((item) => item.target !== null && item.target !== 0) && (
          <Line
            type="monotone"
            dataKey="target"
            stroke="#808080"
            strokeWidth={4}
            fillOpacity={1}
            fill="url(#colorTarget)"
          />
        )}
        {data.some(
          (item) => item.achievement !== null && item.achievement !== 0
        ) && (
          <Line
            type="monotone"
            dataKey="achievement"
            stroke="#7ECF93"
            strokeWidth={4}
            fillOpacity={1}
            fill="url(#colorProfit)"
          />
        )}
        {data.some(
          (item) => item.breakEven !== null && category !== "bookedOrders"
        ) && (
          <Line
            type="monotone"
            dataKey="breakEven"
            stroke="#F48787"
            strokeWidth={2}
            fillOpacity={1}
            fill="url(#colorMinvalue)"
          />
        )}
        {data.some(
          (item) =>
            item.lastYear !== null &&
            item.lastYear !== 0 &&
            category === "bookedOrders"
        ) && (
          <Line
            type="monotone"
            dataKey="lastYear"
            stroke="#FFA500"
            strokeWidth={2}
            fillOpacity={1}
            fill="url(#colorYellow)"
          />
        )}
      </LineChart>
    </div>
  );
};

export default DataChart;
